import { number } from 'yup';

const percentage = number().nullable(true).min(0).max(999.99);

export default percentage;
